export const xx_small = `${10 / 16}rem` as const;
export const x_small = `${11 / 16}rem` as const;
export const small = `${12 / 16}rem` as const;
export const medium = `${13 / 16}rem` as const;
export const large = `${14 / 16}rem` as const;
export const x_large = `${16 / 16}rem` as const;
export const xx_large = `${20 / 16}rem` as const;
export const xxx_large = `${24 / 16}rem` as const;
export const xxxx_large = `${32 / 16}rem` as const;
export const xxxxx_large = `${72 / 16}rem` as const;
